export default __webpack_public_path__ + "static/media/devouringflames.119101c7.png";